import api from '@/api/common/message.js'
const state = {
	stateUnreadyOne: [], //未读消息全部
	stateUnreadyTwo: [], //未读消息平台公告
	stateUnreadyThree: [], //未读消息审核通知,
	// stateIndexOne: [], //全部消息全部
	// stateIndexTwo: [], //全部消息平台公告
	// stateIndexThree: [], //全部消息审核通知,
	statemessageUnreadyNumber:''
}
const mutations = {
	mutationsUnreadyOne(state, data) {
	    state.stateUnreadyOne = data
	},
	mutationsUnreadyTwo(state, data) {
	    state.stateUnreadyTwo = data
	},
	mutationsUnreadyThree(state, data) {
	    state.stateUnreadyThree = data
	},
	// mutationsIndexOne(state, data) {
	//     state.stateIndexOne = data
	// },
	// mutationsIndexTwo(state, data) {
	//     state.stateIndexTwo = data
	// },
	// mutationsIndexThree(state, data) {
	//     state.stateIndexThree = data
	// },
	mutationsMessageNumberFn(state, data) {
	    state.statemessageUnreadyNumber = data
	},
}
const actions = {
	actionsUnreadyFn({}, params = {}) {
		let res = api.messageUnready.requestFun(params)
		return res
	},
	actionsUnreadyNumberFn({commit}, params = {}) {
		let res = api.messageUnreadyNumber.requestFun(params)
		commit('mutationsMessageNumberFn',res)
		return res
	},
}
for (const key in api) {
	if (api[key].mutationsName) {
		state[api[key].stateName] = api[key].stateDefaultName || ''
		mutations[api[key].mutationsName] = (state, data) => {
			if (api[key].getStateName) {
				let getStateNameList = api[key].getStateName.split('.')
				let i = 0
				let stateValue = data
				while (i < getStateNameList.length) {
					stateValue = stateValue[getStateNameList[i]]
					i++
				}
				state[api[key].stateName] = stateValue
			} else {
				state[api[key].stateName] = data
			}
		}
	}
	actions[key] = async ({
		commit
	}, params = {}) => {
		if (api[key].mutationsName) {
			let res = await api[key].requestFun(params)
			commit(api[key].mutationsName, res)
			return res
		} else {
			return api[key].requestFun(params)
		}
	}
}
export default {
	namespaced: true,
	state,
	mutations,
	actions,
}
